/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SendFriendRequestBody
 */
export interface SendFriendRequestBody {
    /**
     * The user ID to send friend request to
     * @type {string}
     * @memberof SendFriendRequestBody
     */
    targetUserId: string;
}

/**
 * Check if a given object implements the SendFriendRequestBody interface.
 */
export function instanceOfSendFriendRequestBody(value: object): value is SendFriendRequestBody {
    if (!('targetUserId' in value) || value['targetUserId'] === undefined) return false;
    return true;
}

export function SendFriendRequestBodyFromJSON(json: any): SendFriendRequestBody {
    return SendFriendRequestBodyFromJSONTyped(json, false);
}

export function SendFriendRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendFriendRequestBody {
    if (json == null) {
        return json;
    }
    return {
        
        'targetUserId': json['targetUserId'],
    };
}

export function SendFriendRequestBodyToJSON(json: any): SendFriendRequestBody {
    return SendFriendRequestBodyToJSONTyped(json, false);
}

export function SendFriendRequestBodyToJSONTyped(value?: SendFriendRequestBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'targetUserId': value['targetUserId'],
    };
}

